import {
    COM_INFRA_CODE, COM_INFRA_CODE_SUCCESS, COM_INFRA_CODE_ERROR,
    COM_INFRA_DESTINATION, COM_INFRA_DESTINATION_SUCCESS, COM_INFRA_DESTINATION_ERROR,
    COM_INFRA_AREA, COM_INFRA_AREA_SUCCESS, COM_INFRA_AREA_ERROR,
    COM_INFRA_PROJECT, COM_INFRA_PROJECT_SUCCESS, COM_INFRA_PROJECT_ERROR,
    COM_INFRA_TYPE, COM_INFRA_TYPE_SUCCESS, COM_INFRA_TYPE_ERROR,
    COM_INFRA_STATUS, COM_INFRA_STATUS_SUCCESS, COM_INFRA_STATUS_ERROR,
    COM_INFRA_SUPPLIER, COM_INFRA_SUPPLIER_SUCCESS, COM_INFRA_SUPPLIER_ERROR,
    COM_INFRA_USER_ASSIGN, COM_INFRA_USER_ASSIGN_SUCCESS, COM_INFRA_USER_ASSIGN_ERROR,
    COM_INFRA_LIST, COM_INFRA_LIST_SUCCESS, COM_INFRA_LIST_ERROR,
    COM_INFRA_SEARCH_CHANGE, COM_INFRA_PAGE_SET,
    COM_INFRA_EDIT_MODAL_SET, COM_INFRA_EDIT_SET_DATA, COM_INFRA_EDIT_CHANGE_SET,
    COM_INFRA_EDIT, COM_INFRA_EDIT_SUCCESS, COM_INFRA_EDIT_ERROR,
    COM_INFRA_ANSWER_MODAL_SET, COM_INFRA_ANSWER_SET_DATA, COM_INFRA_ANSWER_CHANGE_SET,
    COM_INFRA_ANSWER, COM_INFRA_ANSWER_SUCCESS, COM_INFRA_ANSWER_ERROR,
    COM_INFRA_SEE_MODAL_SET, COM_INFRA_SEE_SET_DATA,
    COM_INFRA_UPLOAD_SET, COM_INFRA_UPLOAD_SET_SUCCESS, COM_INFRA_UPLOAD_SET_ERROR, COM_INFRA_UPLOAD_REMOVE, COM_INFRA_UPLOAD_RESET,
} from "../../actions";

const INIT_STATE = {
    loading: false,
    list: {
        page: { current: 1, rows: 10 }
    },
    code: { loading: false, data: [] },
    destination: { loading: false, data: [] },
    area: { loading: false, data: [] },
    project: { loading: false, data: [] },
    type: { loading: false, data: [] },
    status: { loading: false, data: [] },
    supplier: { loading: false, data: [] },
    userassign: { loading: false, data: [] },
    edit: { data: [], modal: false, loading: false, message: '', url: '', type: '' },
    detailanswer: { data: [] },
    answer: { data: [], modal: false, loading: false, message: '', url: '', type: '' },
    detailsee: { data: [] },
    see: { data: [], modal: false, loading: false },
    file: [],
    error: false,
    search: {
        modal: false,
        init: true,
        data: {
            code: '', destination: '', area: '', project: '', type: '', status: '', supplier: '', attend: '', alert: '', urgent: ''
        }
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case COM_INFRA_CODE:
            return { ...state, loading: true, code: { ...state.code } };
        case COM_INFRA_CODE_SUCCESS:
            return { ...state, loading: false, code: { ...state.code, ...action.payload } };
        case COM_INFRA_CODE_ERROR:
            return { ...state, loading: false, error: true };

        case COM_INFRA_DESTINATION:
            return { ...state, loading: true, destination: { ...state.destination } };
        case COM_INFRA_DESTINATION_SUCCESS:
            return { ...state, loading: false, destination: { ...state.destination, ...action.payload } };
        case COM_INFRA_DESTINATION_ERROR:
            return { ...state, loading: false, error: true };

        case COM_INFRA_AREA:
            return { ...state, loading: true, area: { ...state.area } };
        case COM_INFRA_AREA_SUCCESS:
            return { ...state, loading: false, area: { ...state.area, ...action.payload } };
        case COM_INFRA_AREA_ERROR:
            return { ...state, loading: false, error: true };

        case COM_INFRA_PROJECT:
            return { ...state, loading: true, project: { ...state.project } };
        case COM_INFRA_PROJECT_SUCCESS:
            return { ...state, loading: false, project: { ...state.project, ...action.payload } };
        case COM_INFRA_PROJECT_ERROR:
            return { ...state, loading: false, error: true };

        case COM_INFRA_TYPE:
            return { ...state, loading: true, type: { ...state.type } };
        case COM_INFRA_TYPE_SUCCESS:
            return { ...state, loading: false, type: { ...state.type, ...action.payload } };
        case COM_INFRA_TYPE_ERROR:
            return { ...state, loading: false, error: true };

        case COM_INFRA_STATUS:
            return { ...state, loading: true, status: { ...state.status } };
        case COM_INFRA_STATUS_SUCCESS:
            return { ...state, loading: false, status: { ...state.status, ...action.payload } };
        case COM_INFRA_STATUS_ERROR:
            return { ...state, loading: false, error: true };

        case COM_INFRA_SUPPLIER:
            return { ...state, loading: true, supplier: { ...state.supplier } };
        case COM_INFRA_SUPPLIER_SUCCESS:
            return { ...state, loading: false, supplier: { ...state.supplier, ...action.payload } };
        case COM_INFRA_SUPPLIER_ERROR:
            return { ...state, loading: false, error: true };

        case COM_INFRA_USER_ASSIGN:
            return { ...state, loading: true, userassign: { ...state.userassign } };
        case COM_INFRA_USER_ASSIGN_SUCCESS:
            return { ...state, loading: false, userassign: { ...state.userassign, ...action.payload } };
        case COM_INFRA_USER_ASSIGN_ERROR:
            return { ...state, loading: false, error: true };

        case COM_INFRA_LIST:
            return { ...state, loading: true, list: { ...state.list } };
        case COM_INFRA_LIST_SUCCESS:
            return { ...state, loading: false, list: { ...state.list, ...action.payload } };
        case COM_INFRA_LIST_ERROR:
            return { ...state, loading: false, error: true };

        case COM_INFRA_PAGE_SET:
            return { ...state, list: { ...state.list, page: { ...state.list.page, ...action.payload } } };
        case COM_INFRA_SEARCH_CHANGE:
            return { ...state, search: { ...state.search, data: action.payload } };

        case COM_INFRA_EDIT_MODAL_SET:
            return { ...state, edit: { ...state.edit, modal: action.payload } };
        case COM_INFRA_EDIT_SET_DATA:
            return { ...state, edit: { ...state.edit, ...action.payload } };
        case COM_INFRA_EDIT_CHANGE_SET:
            return { ...state, edit: { ...state.edit, data: { ...state.edit.data, ...action.payload } } };
        case COM_INFRA_EDIT:
            return { ...state, edit: { ...state.edit, loading: true } };
        case COM_INFRA_EDIT_SUCCESS:
            return {
                ...state,
                edit: { ...state.edit, modal: false, loading: false, data: [], message: action.payload.message },
                file: []
            };
        case COM_INFRA_EDIT_ERROR:
            return { ...state, edit: { ...state.edit, loading: false } };


        case COM_INFRA_ANSWER_MODAL_SET:
            return { ...state, answer: { ...state.answer, modal: action.payload } };
        case COM_INFRA_ANSWER_SET_DATA:
            return { ...state, detailanswer: { ...state.detailanswer, ...action.payload } };
        case COM_INFRA_ANSWER_CHANGE_SET:
            return { ...state, answer: { ...state.answer, data: { ...state.answer.data, ...action.payload } } };
        case COM_INFRA_ANSWER:
            return { ...state, answer: { ...state.answer, loading: true } };
        case COM_INFRA_ANSWER_SUCCESS:
            return {
                ...state,
                answer: { ...state.answer, modal: false, loading: false, data: [], message: action.payload.message },
                file: []
            };
        case COM_INFRA_ANSWER_ERROR:
            return { ...state, answer: { ...state.answer, loading: false } };

        case COM_INFRA_SEE_MODAL_SET:
            return { ...state, see: { ...state.see, modal: action.payload } };
        case COM_INFRA_SEE_SET_DATA:
            return { ...state, detailsee: { ...state.detailsee, ...action.payload } };

        case COM_INFRA_UPLOAD_SET:
            return {
                ...state,
                file: [...state.file, { uploadId: action.payload.uploadId, original: action.payload.file.name, loading: true }]
            };
        case COM_INFRA_UPLOAD_SET_SUCCESS:
            return {
                ...state,
                file: state.file.map(file => file.uploadId === action.payload.uploadId ? { ...action.payload, loading: false } : file)
            };
        case COM_INFRA_UPLOAD_SET_ERROR:
            return {
                ...state,
                file: state.file.map(file => file.uploadId === action.payload.uploadId ? { ...file, ...action.payload, loading: false } : file)
            };
        case COM_INFRA_UPLOAD_REMOVE:
            return { ...state, file: state.file.filter(file => file.uploadId !== action.payload) };
        case COM_INFRA_UPLOAD_RESET:
            return { ...state, file: [] };

        default:
            return { ...state };
    }
};
